import { useEffect, useRef } from 'react';

export const useScrollSync = (isScrollingSynced: boolean) => {
  const refA = useRef<HTMLDivElement>(null);
  const refB = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!refA.current || !refB.current || !isScrollingSynced) return;

    let isSyncingScroll = false;

    const syncScroll = (
      source: React.RefObject<HTMLDivElement>,
      target: React.RefObject<HTMLDivElement>
    ) => {
      return () => {
        if (isSyncingScroll || !source.current || !target.current) return;
        isSyncingScroll = true;
        target.current.scrollTop = source.current.scrollTop;
        target.current.scrollLeft = source.current.scrollLeft;
        isSyncingScroll = false;
      };
    };

    const handleScrollA = syncScroll(refA, refB);
    const handleScrollB = syncScroll(refB, refA);

    refA.current.addEventListener('scroll', handleScrollA);
    refB.current.addEventListener('scroll', handleScrollB);

    return () => {
      refA.current?.removeEventListener('scroll', handleScrollA);
      refB.current?.removeEventListener('scroll', handleScrollB);
    };
  }, [refA.current, refB.current, isScrollingSynced]);

  return {
    refA,
    refB,
  };
};
